export const CONTROL_UI_TOKEN_SESSION_KEY_PREFIX = "openclaw.control.token.v1:";
export const LEGACY_DEVICE_AUTH_STORAGE_KEY = "openclaw.device.auth.v1";
export const DEVICE_AUTH_STORAGE_KEY_PREFIX = `${LEGACY_DEVICE_AUTH_STORAGE_KEY}:`;
